'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jobs = require('./jobs.html');

var _jobs2 = _interopRequireDefault(_jobs);

var _jobs3 = require('./jobs.controller');

var _jobs4 = _interopRequireDefault(_jobs3);

require('./jobs.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var jobsComponent = {
  restrict: 'E',
  bindings: {},
  template: _jobs2.default,
  controller: _jobs4.default,
  controllerAs: 'vm'
};

exports.default = jobsComponent;


/** WEBPACK FOOTER **
 ** ./client/app/containers/jobs/jobs.component.js
 **/